import { StudyInterface } from './StudyInterface.tsx';
import { DeckHistory } from './DeckHistory.tsx';
import { DeckProgressMap } from './DeckProgressMap.tsx';
import { DeckPageFiles } from './DeckPageFiles.tsx';
import { DeckPageStats } from './DeckPageStats.tsx';
import type { DeckUploadItem, MemberDeckPage } from '../lib/deck-page.ts';
import type { DeckScope } from '../../shared/deck.ts';

export function DeckPageMemberLayout({
  dragging,
  onDraggingChange,
  onFilesSelected,
  onReviewRecorded,
  page,
  scope,
  uploadItem,
  isRefreshing,
  onRetry,
  refreshError,
}: {
  dragging: boolean;
  onDraggingChange: (dragging: boolean) => void;
  onFilesSelected: (files: File[]) => void;
  onReviewRecorded?: () => void;
  page: MemberDeckPage;
  scope?: DeckScope;
  uploadItem: DeckUploadItem | null;
  isRefreshing?: boolean;
  onRetry?: () => void;
  refreshError?: Error | null;
}) {
  return (
    <section className="min-w-0">
      <div className="flex min-h-[calc(100vh-7rem)] flex-col gap-6 content-start">
        <div className="mx-auto min-w-0 w-full max-w-[26rem]">
          <StudyInterface
            deckId={page.member.deckId}
            deckSlug={page.slug}
            onReviewRecorded={onReviewRecorded}
            scope={scope}
          />
        </div>
        <div className="flex min-w-0 flex-col gap-6">
          <DeckHistory
            history={page.member.history}
            isRefreshing={isRefreshing}
            onRetry={onRetry}
            refreshError={refreshError}
          />
          <DeckProgressMap
            deckSlug={page.slug}
            history={page.member.history}
            scope={scope}
          />
          <DeckPageStats page={page} />
        </div>
        {scope && Object.keys(scope).length > 0 ? null : (
          <div className="min-w-0 self-start">
            <DeckPageFiles
              dragging={dragging}
              onDraggingChange={onDraggingChange}
              onFilesSelected={onFilesSelected}
              page={page}
              uploadItem={uploadItem}
            />
          </div>
        )}
      </div>
    </section>
  );
}
